import styled from '@emotion/styled';
import { memo, useEffect, useState } from 'react';
import { proxy, useSnapshot } from 'valtio';
import { fill_horizontal_all_center, fill_vertical_cross_center, } from '~/modules/AppLayout/FlexGridCss';
import { useStkfutDailyRankResource } from '~/modules/screener/containers/useStockScreenerResource';
import { useSymbolWatchList } from '~/modules/WatchList/useSymbolWatchList';
import dayAPI from '~/utils/dayAPI';
import { StockRatioGraph } from '../daddy960_goodway/component/StockRatioGraph';
import { StockScoreRankSlider } from '../daddy960_goodway/component/StockScoreRankSlider';
import { StockScoreSort } from '../daddy960_goodway/component/StockScoreSort';
import { StockScoreTableHeader } from '../daddy960_goodway/component/StockScoreTable';
import { StockVolumeListTable } from '../daddy960_goodway/component/StockVolumeListTable';
import { staticStore } from '../heineken_template/_private/staticStore';
import { store } from '../heineken_template/_private/store';
import { groupStore, watchListConfig } from './daddy960_stocknerve_SidePane2';
import { daddy960_stocknerve_strategyGroup } from './daddy960_stocknerve_initStrategies';
import { fr_instrument } from '~/modules/SDK/FrInstrument/FrInstrument';
export const dayStore = proxy({
    load: false,
});
export const Daddy960_stocknerve_SidePane1 = memo(function Daddy960_stocknerve_SidePane1() {
    const loadState = useSnapshot(dayStore).load;
    const tradedDate = useSnapshot(staticStore).tradedDate.days[2];
    const charting = useSnapshot(store.charting);
    const symbol = charting.symbol;
    const prefix = symbol.substr(0, 2);
    const suffix = symbol.substr(2);
    const isStockFutures = /^[A-Z]{2}$/?.test(prefix) || suffix === 'F-1';
    useEffect(() => {
        if (loadState === true) {
            store.charting.setVisibleRange(tradedDate || dayAPI().subtract(7, 'days'));
        }
    }, [tradedDate, loadState]);
    const [resetIndicators, setResetIndicators] = useState(false);
    return (<styleds.container>
        <styleds.dashboardHeader>
          <div>氣氛靈敏度</div>
          <div>分數排序</div>
        </styleds.dashboardHeader>
        <styleds.dashboard>
          <StockScoreRankSlider />
          <StockScoreSort />
        </styleds.dashboard>
        <styleds.content height={'32px'}>
          <StockRatioGraph />
        </styleds.content>
        <WatchListGroup />
        <styleds.content height={'32px'}>
          <StockScoreTableHeader />
        </styleds.content>
        <styleds.content height={'calc(100% - 188px)'}>
          <StockVolumeList />
        </styleds.content>
      </styleds.container>);
});
/** 觀察清單上的群組選擇器 (預設)(群組1)... */
export const WatchListGroup = memo(function WatchListGroup() {
    const groupState = useSnapshot(groupStore);
    const isDefaultSelect = groupState.defaultData === true;
    return (<styleds.watchListGroupContainer>
      <styleds.watchListGroupButton selected={isDefaultSelect} onClick={() => (groupStore.defaultData = true)}>
        全部
      </styleds.watchListGroupButton>
      {watchListConfig.map((item, index) => {
            const isSelect = item.groupName === groupState.watchListData && !isDefaultSelect;
            return (<styleds.watchListGroupButton key={index} selected={isSelect} onClick={() => {
                    groupStore.watchListData = item.groupName;
                    groupStore.defaultData = false;
                }}>
            {item.displayText}
          </styleds.watchListGroupButton>);
        })}
    </styleds.watchListGroupContainer>);
});
/** 顯示預設股期商品 或是自選商品(過濾非股期商品) */
export const StockVolumeList = memo(function StockVolumeList() {
    const groupState = useSnapshot(groupStore).watchListData;
    const { state } = useSymbolWatchList(groupState);
    const symbolListArray = state.symbolListArray;
    const futuresDisctionary = useSnapshot(staticStore.symbol.stockFuturesMapper);
    /** 自選股的股期商品 */
    const filteredData = symbolListArray?.filter(s => {
        if (futuresDisctionary[s]) {
            return true;
        }
        else
            return false;
    });
    /** 股期成交量前30名 */
    const stkRankData = useStkfutDailyRankResource({
        sort_by: 'volume',
        order_by: 'desc',
        volume_gte: 1,
        volume_lte: 10000000,
        amount_gte: 0,
        amount_lte: 0,
        limit: 50,
    }, 1).data?.map(s => s.symbol) ?? [];
    const resultData = useSnapshot(groupStore).defaultData === true
        ? stkRankData
        : filteredData.map(s => fr_instrument.getFutures(s)?.default?.symbol + '-1' ?? '');
    return (<StockVolumeListTable changeSymbol={true} data={resultData} onClick={() => {
            store.charting.setStrategy(daddy960_stocknerve_strategyGroup.main[0]);
            store.charting.updateFromStrategyState();
        }}/>);
});
const styleds = {
    container: styled.div `
    ${fill_vertical_cross_center};
    padding: 4px;
    gap: 4px;
    font-size: 14px;
    user-select: none;
    background-color: #191919;
  `,
    content: styled.div `
    width: 100%;
    height: ${props => props.height};
  `,
    dashboardHeader: styled.div `
    ${fill_horizontal_all_center};
    grid-template-columns: 70% 30%;
    height: 32px;
    display: grid;
    gap: 4px;
    grid-template-columns: calc(70% - 2px) calc(30% - 2px);
    & > div {
      ${fill_horizontal_all_center};
      background-color: #252525;
      border-radius: 5px;
    }
  `,
    dashboard: styled.div `
    ${fill_horizontal_all_center};
    height: 40px;
    display: grid;
    gap: 4px;
    grid-template-columns: calc(70% - 2px) calc(30% - 2px);
    & > div {
      background-color: #252525;
      border-radius: 5px;
    }
  `,
    watchListGroupContainer: styled.div `
    ${fill_horizontal_all_center};
    height: 30px;
    gap: 4px;
  `,
    watchListGroupButton: styled.div `
    ${fill_horizontal_all_center};
    height: 30px;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.3s;
    background-color: ${props => (props.selected ? '#4759cc' : '#252525')};
    &:hover {
      background-color: ${props => (props.selected ? '#4759cccc' : '#353535')};
    }
  `,
};
